<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-07-19 14:27:03
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2024-03-07 15:37:19
-->
<template>
  <div class="news">
    <div class="ui-hearder-bj news-bj scrollBox">
      <img class="wid100" :src="require('@/assets/images/pc/news/bj.png')" alt="" srcset="">
      <div class="news-bj-txt container">
        <div class="hearder-bj-title news-bj-title">{{$t('news.title')}}</div>
        <div class="hearder-bj-des news-bj-des">{{$t('news.des')}}</div>
      </div>
    </div>
    <div class="container news-content">
      <el-row :gutter='24' class="news-reveal-box">
        <el-col :span='8' v-for="(item,index) in $t('news.reveal')" :key="index">
          <a class="news-reveal-item" :href="item.url" target="_blank">
            <el-image class="news-reveal-item-img transition2" :src="item.poster" :title="item.title" fit="cover"></el-image>
            <h3 class="news-reveal-item-title multiLineText" :title="item.title" v-html="item.title"></h3>
          </a>
        </el-col>
      </el-row>
      <div class="news-list-box"
        v-infinite-scroll="loadNews"
        infinite-scroll-disabled="disabled"
        infinite-scroll-distance="100">
        <div v-for="(item,index) in $t('news.dynamicData').slice(0, limit)" :key="index" :class="['news-list-item']">
          <div class="news-list-item-wrap flex">
            <div class="news-list-item-img"><el-image class="transition2" :src="item.poster" :title="item.title" fit="cover"></el-image></div>
            <div class="flex_1 news-list-item-box textj">
              <a class="news-list-item-title multiLineText" :href="item.url" target="_blank" v-html="item.title"></a>
              <p class="news-list-item-des multiLineText" v-html="item.des"></p>
              <div class="news-list-item-bottom">
                <div class="news-list-item-time fl">{{item.time}}</div>
                <a class="news-list-item-next fr el-icon-right" :href="item.url" target="_blank"></a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p v-if="loading" class="textc">{{$t('news.dropDown')}}<span class="el-icon-d-arrow-right"></span> </p>
      <p v-if="noMore" class="textc">{{$t('news.noMore')}}</p>
    </div>
  </div>
</template>

<script>
import { throttle } from '@/utils'
import { mapGetters } from 'vuex'
export default {
  name: 'news',
  data () {
    return {
      limit: 10,
      loading: false
    }
  },
  computed: {
    ...mapGetters(['device']),
    noMore () {
      return this.limit >= this.$t('news.dynamicData').length
    },
    disabled () {
      return this.loading || this.noMore
    }
  },
  mounted () {
    window.scrollTo(0, 0)
    this.newsListElements = Array.from(document.getElementsByClassName('news-list-item'))
    this.removeListClass()
    this.scrollChange = throttle(this.scrollChange)
    this.scrollChange()
    window.addEventListener('scroll', this.scrollChange, true)
  },
  methods: {
    loadNews () {
      this.loading = true
      const timer = setTimeout(() => {
        clearTimeout(timer)
        this.limit += 20
        this.$nextTick(() => {
          this.newsListElements = Array.from(document.getElementsByClassName('news-list-item'))
        })
        this.loading = false
      }, 1000)
    },
    scrollChange (evt) {
      for (let i = 0; i < this.newsListElements.length; i++) {
        const elem = this.newsListElements[i]
        if (!elem.classList.contains('show')) {
          if (this.isElemVisible(elem)) {
            elem.classList.add('show')
            // this.newsListElements.splice(i, 1) // 只让他执行一次
          }
        }
      }
    },
    removeListClass () {
      for (let i = 0; i < this.newsListElements.length; i++) {
        const elem = this.newsListElements[i]
        elem.classList.remove('show')
      }
    },
    isElemVisible (el) {
      const rect = el.getBoundingClientRect()
      const elemTop = rect.top
      const elemBottom = rect.bottom
      return elemTop < window.innerHeight && elemBottom >= 0
    }
  },
  destroyed () {
    window.removeEventListener('scroll', this.scrollChange, true)
  }
}
</script>

<style lang="less" scoped>
.news {
  .news-bj {
    position: relative;
    top: -1PX;
    img{
      margin-bottom: -3PX;
    }
    .news-bj-txt {
      position: absolute;
      right: 0;
      top: 180PX;
    }
  }
  .news-content {
    padding-bottom: 50PX;
    .news-reveal-box {
      padding: 50PX 0 28PX 0;
      .news-reveal-item {
        position: relative;
        height: 300PX;
        display: block;
        overflow: hidden;
        &:hover {
          .news-reveal-item-title {
            background: rgba(0, 134, 192, 0.6);
          }
          .news-reveal-item-img{
            transform: scale(1.1);
          }
        }
        .news-reveal-item-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        .news-reveal-item-title{
          position: absolute;
          bottom: 0;
          height: 53PX;
          line-height: 53PX;
          width: 100%;
          padding: 0 23PX;
          color: #ffffff;
          background: rgba(0, 0, 0, 0.3);
        }
      }
    }
    .news-list-box {
      color: #333333;
      line-height: 26PX;
      padding-bottom: 30PX;
      font-size: 18PX;
      overflow: auto;
      .news-list-item {
        overflow: hidden;
        .news-list-item-wrap {
          padding: 52PX 0;
          border-bottom: 1PX solid rgba(151, 151, 151, 0.2);
          -webkit-transform: translate3d(0, 100%, 0);
          transform: translate3d(0, 100%, 0);
          -moz-transform: translate3d(0, 100%, 0);
          -ms-transform: translate3d(0, 100%, 0);
          -o-transform: translate3d(0, 100%, 0);
        }
        .news-list-item-img {
          width: 258PX;
          height: 171PX;
          overflow: hidden;
          .el-image {
            width: 100%;
            height: 100%;
          }
          &:hover .el-image {
            transform: scale(1.1);
          }
        }
        .news-list-item-box {
          padding-left: 32PX;
          position: relative;
          &:hover {
            .news-list-item-title {
              color: #00A0E9;
            }
          }
          .news-list-item-title {
            font-size: 20PX;
            font-weight: bold;
            padding-bottom: 20PX;
            color: #333333;
            display: block;
          }
          .news-list-item-des {
            color: rgba(51, 51, 51, 0.6);
          }
          .news-list-item-bottom {
            position: absolute;
            bottom: -10PX;
            width: calc(100% - 32PX);
            line-height: 32PX;
            .news-list-item-next{
              color: #C2C2C2;
              font-size: 32PX;
            }
          }
        }
        &.show .news-list-item-wrap{
          -webkit-transform: translateZ(0);
          transform: translateZ(0);
          -moz-transform: translateZ(0);
          -ms-transform: translateZ(0);
          -o-transform: translateZ(0);
          transition: all 1s;
        }
      }
    }
  }
}
</style>
